import React from 'react';
import PropTypes from 'prop-types';

import './style.scss';

export function WarningContainer(props) {
  return (
    <div className='mc_frontView_warningContainer'>
      <div className='mc_frontView_warningContainer_alignmentTop' />
      <div className='mc_frontView_warningContainer_alignmentRight' />
      <div className='mc_frontView_warningContainer_alignmentBottom' />
      <div className='mc_frontView_warningContainer_alignmentLeft' />
      {props.children}
    </div>
  );
}

WarningContainer.propTypes = {
  /**
   * chilkd components passed
   */
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
};

WarningContainer.defaultProps = {};
